import React from 'react';
import { Button } from './ui/Button';
import { SectionFade } from './ui/SectionFade';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-brand-black" data-id="element-115">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(200,255,0,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-116"></div>

      <div className="max-w-5xl mx-auto text-center z-10 w-full" data-id="element-117">
        <SectionFade data-id="element-118">
          <h2 className="text-brand-neon font-inter font-bold tracking-widest uppercase text-xs md:text-sm mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-119">
            El sistema de 5 segundos para detectar azúcar, aceites inflamatorios
            y químicos ocultos antes de llegar a la caja registradora.
          </h2>
        </SectionFade>

        <SectionFade delay={0.1} data-id="element-120">
          <h1 className="font-bebas text-7xl md:text-8xl lg:text-[10rem] leading-[0.85] mb-6 tracking-tight" data-id="element-121">
            DEJA DE COMER <br data-id="element-122" />
            <span className="text-brand-neon bg-brand-neon/10 px-4 inline-block mt-2" data-id="element-123">
              MENTIRAS
            </span>
          </h1>
        </SectionFade>

        <SectionFade delay={0.2} data-id="element-124">
          <p className="text-xl md:text-3xl font-bebas tracking-wide text-gray-300 mb-12 max-w-3xl mx-auto" data-id="element-125">
            EL MANUAL PARA DESENMASCARAR A LA INDUSTRIA ALIMENTARIA
          </p>
        </SectionFade>

        <SectionFade delay={0.3} data-id="element-126">
          <div className="relative w-full max-w-4xl mx-auto mb-12" data-id="element-127">
            <div className="absolute inset-0 bg-brand-neon/20 blur-[100px] rounded-full" data-id="element-128"></div>
            <img src="https://cdn.magicpatterns.com/uploads/fxezBkowQ3XbGR5tmBXwCp/heylloyd-image-1776126770042.png" alt="Deja de Comer Mentiras - Mockup de dispositivos" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-129" />
          </div>
        </SectionFade>

        <SectionFade delay={0.4} data-id="element-130">
          <Button href="#pricing" className="w-full md:w-auto" data-id="element-131">
            QUIERO DEJAR DE SER ENGAÑADO AHORA
          </Button>
        </SectionFade>
      </div>
    </section>;
}